import React, { Component } from 'react';
import { Link,withRouter, } from 'react-router-dom';

import * as routes from '../constants/routes';
import { auth } from '../firebase';
import firebase from 'firebase';

var pageStyle = {
  //backgroundImage: 'url(' + imgUrl + ')',
  textAlign: "justify",
  padding: "60px",
  margin: "20px",
  WebkitTransition: 'all', // note the capital 'W' here
  msTransition: 'all' // 'ms' is the only lowercase vendor prefix
};


const INITIAL_STATE = {
  username: '',
  company: '',
  telephoneNumber: '',
  eligible: '',
  email: '',
  shouldemail: 'no',
  questionnaire:"[0,0,0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0]",
  passwordOne: '',
  passwordTwo: '',
  error: null,
};


const SignUpPage = ({ history }) =>
  <div style={pageStyle} >
    <h2>Sign Up Here To Start the Risk Assessment</h2>
    <p>Please enter the <i>name of the person who should receive the risk assessment</i> and the <i>organisation name that you want to appear in the report</i>. Optionally, please also enter a telephone contact number.  Then enter the <i>email address</i> of the chosen recipient and  a <i>password</i> to be used to restrict access. Remember to sign out when you are finished or want to complete the assessment later.</p> <p> The report will be sent to the email address that you provide here.</p>
    <SignUpForm history={history} />
    <p>After signing up you simply <i>sign out</i> whenever you want and you can <i>sign in</i> again to complete the assessment. </p>
  </div>


  const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});


class SignUpForm extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };

  }

  onSubmit = (event) => {


    const {
      username,
      company,
      telephoneNumber,
      eligible,
      email,
//      shouldemail,
//      questionnaire,
      passwordOne,
      } = this.state;


 


    const {
          history,
        } = this.props;

     auth.doCreateUserWithEmailAndPassword(email, passwordOne)

//*******************************************************

.then (()=>{firebase.auth().onAuthStateChanged(function(user) {
  if (user) {
    // User is signed in.
    console.log("email of user  signed in SignUpPage  " + user.email);
    console.log("firebase uid of user is signed in Sign Up  " + user.uid);

      var ref = firebase.database().ref('/users/' + user.uid);

      console.log("firebase reference   " + ref);

      const sud=new Date().toJSON();

      const cust = {
        username: username,
        company: company,
        telephoneNumber: telephoneNumber,
        id: user.email,
        signupdate: sud,
        questionnaire: "[0,0,0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0]",
        shouldemail: "no",
        date: new Date().toJSON(),
        eligible: eligible
        }


          const usersRef = firebase.database().ref('users/' + user.uid);
          usersRef.set(cust);

          //var userId = firebase.auth().currentUser.uid; //This is the firebase unique user ID
          //console.log('User  uid in SignUp !  ' + userId);
        //const usersRef = firebase.database().ref('users');
        //usersRef.child(userId).set(cust); 


/*
      
        localStorage.clear();
        // put ino local storage as may go straight and answer all questiosnand submit
   // note that when signing in we read all the values below from the saved firebase state and reset the local storage
   
   console.log("+++++++++++++++++Storing ++++++++++++++++++");
   // making what is in local storage the same as what is put into firebase
   localStorage.setItem("company",company);
   localStorage.setItem("username",username);
   localStorage.setItem("eligible",eligible);
   localStorage.setItem("telephoneNumber",telephoneNumber);
   localStorage.setItem("signupdate",sud);
   localStorage.setItem("questionnaire","[0,0,0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0]"); 
   localStorage.setItem("id",user.email);
   localStorage.setItem("date",sud);  
   localStorage.setItem("shouldemail", 'no');
   localStorage.setItem("justsignedup", 'yes');
*/
console.log("exit signUP"  );

}


else {
    // No user is signed in
    console.log('No user ! SignUp ' + user.email);
  }
}
)})

//**********************************************************
.then(authUser => {
  this.setState(() => ({ ...INITIAL_STATE }));
  history.push(routes.HOME);
})


//*******************************************************

      .catch(error => {
        this.setState(byPropKey('error', error));
      });

      event.preventDefault();
     }

  render() {

    const {
      username,
      company,
      telephoneNumber,
//      eligible,
      email,
//      shouldemail,
//      questionnaire,
      passwordOne,
      passwordTwo,
      error,
    } = this.state;


    const isInvalid =
      passwordOne !== passwordTwo ||
      passwordOne === '' ||
      email === '' ||
      username === '' ||
      company==='';
// telephoneNumber is deliberately left out as optional

    return (
      <form onSubmit={this.onSubmit}>
            <div>  <input
                value={username}
                onChange={event => this.setState(byPropKey('username', event.target.value))}
                type="text"
                placeholder="Full Name"
              />
              <input
                value={company}
                onChange={event => this.setState(byPropKey('company', event.target.value))}
                type="text"
                placeholder="Company"
              />

              <input
                value={telephoneNumber}
                onChange={event => this.setState(byPropKey('telephoneNumber', event.target.value))}
                type="text"
                placeholder="Telephone Number"
              />
              </div>
              <p></p>
              <div>
              <input
                value={email}
                onChange={event => this.setState(byPropKey('email', event.target.value))}
                type="text"
                placeholder="Email Address"
              />
              <input
                value={passwordOne}
                onChange={event => this.setState(byPropKey('passwordOne', event.target.value))}
                type="password"
                placeholder="Password"
              />
              <input
                value={passwordTwo}
                onChange={event => this.setState(byPropKey('passwordTwo', event.target.value))}
                type="password"
                placeholder="Confirm Password"
              />
              <button disabled={isInvalid} type="submit">
                Sign Up
              </button>
              </div>

              { error && <p>{error.message}</p> }
      </form>
    );
  }
}

const SignUpLink = () =>
  <p>
    Do not have an account?
    {' '}
    <Link to={routes.SIGN_UP}>Sign Up</Link>
  </p>



export default withRouter(SignUpPage);

export {
  SignUpForm,
  SignUpLink,
};



// WEBPACK FOOTER //
// ./src/components/SignUp.js